import type { ID } from 'types';

export const tieredPricingKeys = {
  all: () => ['tiered_pricing'] as const,
  configuration: (eventId: ID) => [...tieredPricingKeys.all(), 'configuration', eventId] as const,
};
